module.exports = __webpack_public_path__ + "img/upgrade_selector_highlight.d5e5ac43.png";